import { useAppDisplayModeContext } from '@archipro-design/aria';

import { PageHeaderDesktop } from './PageHeader.desktop';
import { PageHeaderMobile } from './PageHeader.mobile';
import type { ProjectPageLoader } from '@modules/project/type';

export interface PageHeaderProps {
    data: ProjectPageLoader['project'];
    isEditPage?: boolean;
}

const PageHeader = ({ data }: PageHeaderProps) => {
    const { desktop } = useAppDisplayModeContext();

    return desktop ? (
        <PageHeaderDesktop data={data} />
    ) : (
        <PageHeaderMobile data={data} />
    );
};

export default PageHeader;
